import { render, staticRenderFns } from "./InstructorPayrollOld.vue?vue&type=template&id=1b411708&scoped=true"
import script from "./InstructorPayrollOld.vue?vue&type=script&lang=js"
export * from "./InstructorPayrollOld.vue?vue&type=script&lang=js"
import style0 from "./InstructorPayrollOld.vue?vue&type=style&index=0&id=1b411708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b411708",
  null
  
)

export default component.exports